module.exports = __webpack_public_path__ + "static/media/main-hero-working-ipad.c60d89e2.png";